import React from 'react';
import { PropTypes as PT } from 'prop-types';
import NotificationMessage from 'components/NotificationMessage/NotificationMessage';
import {
  NOTIFICATION_TYPE_MESSAGE,
} from 'constants/Notification';
import classes from './Notification.module.scss';

/**
 * Notification component
 */
class Notification extends React.PureComponent {
  getNotificationComponent(notification) {
    let component;
    switch (notification.type) {
      case NOTIFICATION_TYPE_MESSAGE:
        component = (
          <NotificationMessage
            id={notification.id}
            removeNotification={this.props.removeNotification}
            {...notification.props}
          />
        );
        break;
      default:
        component = null;
    }
    return component;
  }

  render() {
    if (!this.props.notifications.length){
      return null;
    }

    return (
      <ul className={classes.container}>
        {this.props.notifications.map(notification => (
          <li key={notification.id}>
            {this.getNotificationComponent(notification)}
          </li>
        ))}
      </ul>
    );
  }
}

Notification.propTypes = {
  notifications: PT.array,
  removeNotification: PT.func,
};

Notification.defaultProps = {
  notifications: []
};

export default Notification;
